import React, { Fragment, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { ButtonContainer, SubheaderSection, TextField } from "../../components";
import { Formik } from "formik";
import * as Yup from "yup";

import { useNavigate } from "react-router-dom";
import pages from "../../constants/pages";
import { useAxios } from "../../hooks";
import { setUserName } from "../../redux/slices/memberSlice";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "5.5px",
    background: "rgb(255, 255, 255)",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const ContentBox = styled(Box)({
  padding: "20px",
  textAlign: "center",
  alignContent: "center",
  alignItems: "center",
});

const NewUserDetails = ({}) => {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { visitorData, authToken } = useSelector(
    (state) => state.memberDetails
  );

  const [popup, setPopup] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
  });

  useEffect(() => {
    setPopup(
      !visitorData.phoneNumber ? false : !!visitorData.firstName ? false : true
    );
  });

  return (
    <StyledDialog open={popup} fullWidth maxWidth="md">
      <DialogContent style={{ padding: "0px" }}>
        <ContentBox>
          <SubheaderSection
            textAlign="start"
            variant="h5"
            title={`Enter your name as on your government ID`}
            titleColor="#2b2b2b"
            titleProps={{ fontWeight: 700 }}
          />
          <Grid container>
            <Formik
              initialValues={{ name: "" }}
              validationSchema={validationSchema}
              onSubmit={(formData, { setSubmitting }) => {
                const name = formData.name.split(" ");
                axios({
                  url:
                    "/admin/profile/edit-profile?visitor_id=" + visitorData.ID,
                  method: "POST",
                  data: {
                    first_name: name[0] || "",
                    last_name: name.slice(1).join(" ") || "",
                  },
                  customAuthToken: sessionStorage.getItem("authToken"),
                }).then((response) => {
                  if (response.status) {
                    dispatch(setUserName(formData.name));
                    setPopup(false);
                    navigate(
                      sessionStorage.getItem("previousPage") || pages.home.route
                    );
                  }
                });
              }}
            >
              {(formikProps) => {
                return (
                  <Fragment>
                    <Grid item container>
                      <TextField
                        name="name"
                        size="small"
                        placeholder="Enter Your Name"
                        formikProps={formikProps}
                      ></TextField>
                    </Grid>
                    <Grid item container justifyContent={"end"} mt={2}>
                      <Button
                        size="small"
                        variant="contained"
                        disabled={!formikProps.dirty || !formikProps.isValid}
                        onClick={formikProps.handleSubmit}
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Fragment>
                );
              }}
            </Formik>
            <Grid></Grid>
          </Grid>
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
};

export default NewUserDetails;
